import { render } from "./LicenseManagement.vue?vue&type=template&id=5b070016&scoped=true"
import script from "./LicenseManagement.vue?vue&type=script&lang=js"
export * from "./LicenseManagement.vue?vue&type=script&lang=js"

import "./LicenseManagement.vue?vue&type=style&index=0&id=5b070016&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b070016"]])

export default __exports__